export default "__VITE_ASSET__Db5YXmE___"